<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title=" Senarai Akaun Belum Terima">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <z-lookup
                            label="Bulan"
                            url="bulanlookup"
                            :sort="false"
                            :cache="false"
                            v-model="cari.bulan"
                        />
                        <!-- <z-lookup v-if="show_jabatan == true"
                            label="Jabatan"
                            :url="service_kutipan + 'lookup/jabatan_user2'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.jabatan_id"
                        /> -->
                    </div>
                    <div class="xs6 mr3">
                        <w-input v-model="cari.tahun" type="number" label="Tahun" />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>Bil</td>
                                <td>Butiran/Perkara</td>
                                <td>ABT (Selepas Pelarasan dan Terimaan)<br>(1)<br>(RM)</td>
                                <td>Amaun Hapus Kira Yang Diluluskan<br>(2)<br>(RM)</td>
                                <td>Jumlah Bersih ABT<br>(3) = (1) - (2)<br>(RM)</td>
                                <td>Jumlah Penjejasan Nilai Terkumpul<br>(4)<br>(RM)</td>
                                <td>Jumlah Tunggakan<br>(5)<br>(RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="this.table.jumlah">
                                <tr>
                                    <td>1</td>
                                    <td>
                                        <inertia-link v-if="this.table.jumlah" :href="$route('pendidikan.akaun_belum_terima.abt_1a')+'?from_abt=true' + '&bulan=' + cari.bulan + '&tahun=' +cari.tahun">
                                        ABT Pinjaman Dan Pendahuluan
                                        </inertia-link>
                                    </td>
                                    <td style="text-align: right"><span v-if="this.table.jumlah">{{this.table.jumlah}}</span><span v-else>0.00</span></td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right"><span v-if="this.table.jumlah">{{this.table.jumlah}}</span><span v-else>0.00</span></td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right"><span v-if="this.table.jumlah">{{this.table.jumlah}}</span><span v-else>0.00</span></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Pelbagai ABT:</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                </tr>
                                <tr>
                                    <td>2.1</td>
                                    <td>
                                        <inertia-link v-if="this.table.jumlah" :href="$route('pendidikan.akaun_belum_terima.abt_1b')+'?from_abt=true' + '&bulan=' + cari.bulan + '&tahun=' +cari.tahun">
                                            ABT Hasil
                                        </inertia-link>
                                    </td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                </tr>
                                <tr>
                                    <td>2.2</td>
                                    <td>
                                        <inertia-link v-if="this.table.jumlah" :href="$route('pendidikan.akaun_belum_terima.abt_1c')+'?from_abt=true' + '&bulan=' + cari.bulan + '&tahun=' +cari.tahun">
                                            ABT Hutang-Hutang lain
                                        </inertia-link>
                                    </td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                </tr>
                                <tr>
                                    <td>2.3</td>
                                    <td>
                                        <inertia-link v-if="this.table.jumlah" :href="$route('pendidikan.akaun_belum_terima.abt_1d')+'?from_abt=true' + '&bulan=' + cari.bulan + '&tahun=' +cari.tahun">
                                            ABT Faedah Pinjaman Boleh Dituntut
                                        </inertia-link>
                                    </td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>
                                        <inertia-link v-if="this.table.jumlah" :href="$route('pendidikan.akaun_belum_terima.abt_1e')+'?from_abt=true' + '&bulan=' + cari.bulan + '&tahun=' +cari.tahun">
                                            ABT Wang Pendahuluan Kontraktor
                                        </inertia-link>
                                    </td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right">0.00</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>Jumlah Keseluruhan</td>
                                    <td style="text-align: right"><span v-if="this.table.jumlah">{{this.table.jumlah}}</span><span v-else>0.00</span></td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right"><span v-if="this.table.jumlah">{{this.table.jumlah}}</span><span v-else>0.00</span></td>
                                    <td style="text-align: right">0.00</td>
                                    <td style="text-align: right"><span v-if="this.table.jumlah">{{this.table.jumlah}}</span><span v-else>0.00</span></td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="7" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan+'kutipan/laporan/dummy',
            reload: true,
            loading: false,
            status: [
                {
                    value: 1,
                    label: "Aktif",
                },
                {
                    value: 2,
                    label: "Tidak Aktif",
                },
            ],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Pendidikan", route: "/pendidikan" },
                {
                    label: "Akaun Belum Terima",
                    route: "/pendidikan/akaun_belum_terima",
                },
                { label: "ABT 1", route: "/pendidikan/akaun_belum_terima/abt_1" },
            ],
            cari: { bulan: "", tahun: "", jabatan_id: ""},
        };
    },
    methods: {
        search() {
            this.getDataQuery();
            // this.$inertia.visit(
            //     window.route("akaun_belum_terima.abt_1") +
            //         "?bulan=" +
            //         this.cari.bulan +
            //         "&tahun=" +
            //         this.cari.tahun,
            //     { preserveScroll: true }
            // );
        },

        reset() {
            this.cari = { bulan: "", tahun: "", jabatan_id: ""};
            this.search();
        },

        cetak() {
            window.open(this.service_tunggakan+'abt/pendidikan?cetak=true&user_id='+this.auth.user.id+
            "&bulan=" + this.cari.bulan + '&from=abt1' +
            "&tahun=" + this.cari.tahun +
            "&jabatan_id=" + this.cari.jabatan_id
            ,'_blank');
        },
        async getDataQuery() {
            this.loading = true;
            const resp = await axios.get(
                this.service_tunggakan + "abt/pendidikan?user_id=" + this.auth.user.id +
                    "&bulan=" + this.cari.bulan +
                    "&tahun=" + this.cari.tahun +
                    "&jabatan_id=" + this.cari.jabatan_id
            );
            this.table = resp.data;
            this.loading = false;
        },
    },
    watch: {},
    mounted() {
        // override default setting
        // this.getData();
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.bulan == "undefined") {
            this.cari.bulan = "";
        }
        if (this.cari.tahun == "undefined") {
            this.cari.tahun = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
        // console.log(this.auth.user);
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
